    $(function() {
        $('.ranking-sbox').slick(
          {
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [{
                  breakpoint: 640,settings: { 
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                  }}]
          }
        ); 
    });
